import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getResultBidding } from 'store/modules/market_store/actions';
import { ApplicationState } from 'store';
import { MarketState } from 'store/modules/market_store/types';

interface ResultBodyProps {
  bidding_id: string;
}

export const ResultBody: React.FC<ResultBodyProps> = ({ bidding_id }) => {
  const dispatch = useDispatch();

  const { bidding_result, request } = useSelector<ApplicationState, MarketState>(
    (state) => state.session.market,
  );

  useEffect(() => {
    if (bidding_id) {
      dispatch(getResultBidding(bidding_id));
    }
  }, [bidding_id]);

  const resultados = bidding_result?.resultados || [];

  const calc = () => {
    let total = resultados.reduce((acc, curr) => acc + (curr.item_valor_total || 0), 0);
    if (total === 0) {
      total = resultados.reduce((acc, curr) => acc + (curr.item_valor_unitario || 0), 0);
    }
    return total.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
  };

  if (request?.bidding_result?.loading) {
    return <div className="alert alert-info">Carregando resultados...</div>;
  }

  if (!resultados.length) {
    return <div className="alert alert-info">Nenhum resultado disponível para essa licitação</div>;
  }

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="mb-3">
          <div className="card shadow p-0">
            <table className="table table-status-resultados mb-0">
              <tbody className="tbody-modal">
                <tr>
                  <td className="text-center align-middle">
                    <b>Nº de itens</b> <br /> {resultados.length}
                  </td>
                  <td className="text-center align-middle">
                    <b>Valor global</b> <br /> {calc()}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="card shadow p-0">
          <div className="table-responsive" style={{ maxHeight: '350px' }}>
            <table className="table table-hover table-resultados">
              <thead className="table-thead-fixed">
                <tr>
                  <th className="w-25">Item</th>
                  <th>Vencedor</th>
                  <th>Un.</th>
                  <th>Qtd.</th>
                  <th>Valor un.</th>
                  <th>Valor total</th>
                </tr>
              </thead>
              <tbody className="tbody-modal">
                {resultados.map((resultado) => (
                  <tr key={resultado.id}>
                    <td>{resultado.item_descricao}</td>
                    <td>
                      <a
                        href={
                          resultado.cnpj.toString().length === 13
                            ? `/concorrentes/0${resultado.cnpj}`
                            : `/concorrentes/${resultado.cnpj}`
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        {resultado.fornecedor}
                      </a>
                    </td>
                    <td>{resultado.item_unidade}</td>
                    <td>{resultado.item_quantidade}</td>
                    <td>
                      {resultado.item_valor_unitario?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      }) || ' - '}
                    </td>
                    <td>
                      {resultado.item_valor_total?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                      }) || ' - '}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
